import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";



export const addUpdateBrand = createAsyncThunk("brand/addupdate", async (reqbody) => {

    console.log("reqbody==>", reqbody);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqbody)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "api6/addorupdatebrand", requestOptions);
    const respdata = await response.json();
    console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
});


export const getBrandtList = createAsyncThunk("brand/list", async (reqbody) => {

    // console.log("reqbody==>", reqbody);

    let req_body = {};
    req_body= {...reqbody};
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "api6/brandlistings", requestOptions);
    const respdata = await response.json();
    // console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
});

////api call for users listing//////////////
export const statusChange = createAsyncThunk("brand/statuschange", async (reqbody) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqbody)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api6/brandstatusupdate", requestOptions);
    const respdata = await response.json();
    return respdata;

})


const brandManagment = createSlice({
    name: 'brandManagment',
    initialState: {
        submitting: false,
        // product: {},
        submitted: false,
        message: null,
        loading: false,
        success: false,
        successmsg: "",
        brandList: [],
        brandList_Count: null,
        // cartData: []
    },
    reducers: {

        // setSuccessAfterSubmit(state, action) {
        //     state.success = false;
        // },

        // setAddToCart(state, action) {
        //     state.cartData = [...state.cartData, action.payload.productData];
        // },
    },

    extraReducers: {
        /// For GEt Product List
        [getBrandtList.rejected]: (state, action) => {
            state.loading = false;
        },
        [getBrandtList.pending]: (state, action) => {
            // console.log("action p", action)
            // state.brandList = [];
            state.loading = true;
        },
        [getBrandtList.fulfilled]: (state, action) => {
            console.log("action f", action)
            if (action.payload.status === 'success') {
                state.brandList = action.payload.results.res;
                state.message = action.payload.status;
                // state.submitted = true;
                state.loading = false;

            }
        },   
        /*********************For Edit Brand********* */
        [addUpdateBrand.pending]: (state, action) => {
            state.loading = true;
        },
        [addUpdateBrand.fulfilled]: (state, action) => {
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Updated Successfully';
                state.success = true;
            }
        },
        [addUpdateBrand.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },

        [statusChange.rejected]: (state, action) => {
            state.loading = false;
        },
        [statusChange.pending]: (state, action) => {
            state.loading = true;
            state.success = false;
        },
        [statusChange.fulfilled]: (state, action) => {
            state.loading = false;
            if(action.payload.status == 'success'){
                state.success = true
            }
        }


    }

})

export default brandManagment.reducer;
export const {  } = brandManagment.actions;